import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { consoleDebug, isDebug } from '@shared/pipes/is-debug'

export const sendStep1SignForm = () => {
	if (isDebug()) {
		return consoleDebug('[Sign form] - prevent send form')
	}

	return httpService.post(apiUrls.esia.getSignConfig())
}
